module.exports = __webpack_public_path__ + "static/assets/b8aa30bdb0ca4194176b70d440295b3f.gif";